module.exports = __webpack_public_path__ + "assets/Kopfschmerz.c2a61206.png";